import { Link } from "@tanstack/react-router";
import { Icon } from "icons";
import {
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  useSidebar,
} from "ui";

import { type SidebarHeaderConfig } from "src/staticData";

interface SidebarHeaderLinkProps {
  header: Extract<SidebarHeaderConfig, { type: "link" }>;
}
export function SidebarHeaderLink(props: SidebarHeaderLinkProps) {
  const sidebar = useSidebar();

  return (
    <SidebarMenu>
      <SidebarMenuItem>
        <SidebarMenuButton asChild tooltip={props.header.tooltip}>
          <Link
            to={props.header.href ?? "/"}
            className="gap-2"
            onClick={() => {
              sidebar.setOpenMobile(false);
            }}
          >
            {props.header.iconName ? (
              <Icon name={props.header.iconName} />
            ) : null}
            {props.header.text ? <span>{props.header.text}</span> : null}
          </Link>
        </SidebarMenuButton>
      </SidebarMenuItem>
    </SidebarMenu>
  );
}
